import { render, staticRenderFns } from "./qyxxbgLook1.vue?vue&type=template&id=7a5d7142&scoped=true&"
import script from "./qyxxbgLook1.vue?vue&type=script&lang=js&"
export * from "./qyxxbgLook1.vue?vue&type=script&lang=js&"
import style0 from "./qyxxbgLook1.vue?vue&type=style&index=0&id=7a5d7142&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5d7142",
  null
  
)

export default component.exports